import { useCallback } from 'react';

import { NETWORK_NAME } from 'constants/index';
import { useLPBondsPrices } from 'hooks/useLPBondsPrices';
import useWalletContext from 'hooks/useWalletContext';
import { formatBigDecimalNumbers, formatNumber, removeCommas } from 'utils/numbers';
import { formatHumanReadableTime } from 'utils/helper';

const useFormatOfferResponse = () => {
  const { coinPrice, getChainPrice } = useLPBondsPrices();
  const { storedChain } = useWalletContext();

  const formatOfferResponse = useCallback(
    async (offerResponse) => {
      if (!offerResponse?.length) {
        return;
      }
      const offerNfts = offerResponse.map(async (offer) => {
        const { maker } = offer ?? {};
        const price = formatBigDecimalNumbers(Number(offer.OrderAmountEth));

        // Use current chain context - API responses are chain-specific
        const chainName = NETWORK_NAME[storedChain]?.toLowerCase() || 'ethereum';
        const usdPrice = getChainPrice(chainName) || coinPrice;
        const dollarPrice = formatNumber(Number(removeCommas(price)) * usdPrice);

        return {
          ...offer,
          price,
          dollarPrice,
          collection: offer?.contract?.name,
          collectionFloorPrice: offer?.contract?.floorPrice,
          tooltipDate: formatHumanReadableTime(Number(offer.MatchBeforeTimestamp) * 1000),
          pageLink: `/lp-bonds/${chainName}/asset/${offer.NftContract}/${offer.NftToken}`,
          name: offer?.token?.name,
          buyer: maker?.username || maker?.ensDomain || maker?.address?.slice(0, 6),
          buyerAddress: maker?.address,
        };
      });

      const formattedOffers = await Promise.all(offerNfts);
      return formattedOffers;
    },
    [coinPrice, getChainPrice, storedChain],
  );

  return formatOfferResponse;
};

export default useFormatOfferResponse;
